import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';

interface MaskedTokenValueProps {
  value: string;
  isBold?: boolean;
}

const MaskedTokenValue: React.FC<MaskedTokenValueProps> = ({ value, isBold = true }) => {
  const [ showFullValue, setShowFullValue ] = useState(false);
  const toggleValueVisibility = (event: React.MouseEvent) => {
    // イベントの伝播を停止して親要素のクリックイベントが発火しないようにする
    event.stopPropagation();
    setShowFullValue(!showFullValue);
  };
  // トークン値の一部をマスクする関数
  const maskTokenValue = (value: string): string => {
    if (!value || value.length <= 8) return "********";
    // 最初の4文字と最後の4文字を表示し、間をマスク
    const firstPart = value.substring(0, 4);
    const lastPart = value.substring(value.length - 4);
    return `${firstPart}***${lastPart}`;
  };
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} className="no-propagation">
      <Typography
        component="span"
        sx={{
          fontWeight: isBold ? 'bold' : 'normal',
          fontFamily: 'monospace',
          fontSize: '0.85rem'
        }}
      >
        {showFullValue ? value : maskTokenValue(value)}
      </Typography>
      <Tooltip title={showFullValue ? "トークンを隠す" : "トークンを表示する"}>
        <IconButton
          size="small"
          onClick={toggleValueVisibility}
          sx={{ ml: 1 }}
          className="no-propagation"
        >
          {showFullValue ? <VisibilityOffIcon fontSize="small"/> : <VisibilityIcon fontSize="small"/>}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
export default MaskedTokenValue;
